const API_URL = process.env.REACT_APP_API_URL1;
const TENANT = localStorage.getItem("tenant") || "";
const commonHeaders = {
  "X-Tenant": TENANT
};

// Fetch all beacons
export const fetchBeacons = async () => {
  const res = await fetch(`${API_URL}/beacons/all-beacons`, {
    headers: {
      ...commonHeaders
    },
    credentials: "include"
  });
  const data = await res.json();
  return data.beacons || [];
};

// Add new beacon
export const addBeacon = async (payload) => {
  const res = await fetch(`${API_URL}/beacons/add`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...commonHeaders
    },
    credentials: "include",
    body: JSON.stringify(payload)
  });
  return res.json();
};

// Update existing beacon
export const updateBeacon = async (id, payload) => {
  const res = await fetch(`${API_URL}/beacons/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...commonHeaders
    },
    credentials: "include",
    body: JSON.stringify(payload)
  });
  return res.json();
};

// Delete a beacon
export const deleteBeacon = async (id) => {
  const res = await fetch(`${API_URL}/beacons/${id}`, {
    method: "DELETE",
    headers: {
      ...commonHeaders
    },
    credentials: "include"
  });
  return res.json();
};